import { DashboardOrderStats } from '../../../models';

export const getDashboardOrderStats = (data: any): DashboardOrderStats => {
  return {
    todayCount: data.today_count,
    thisMonthCount: data.this_month_count
  };
}
